import { computed } from 'vue'
import type { ComputedRef } from 'vue'

import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'

/**
 * Pode AUDITAR registro de plantão (`attendance_basic_receiving`) em algum recurso
 * do ds_attendance — escala, unidade ou empresa, como a fila já resolve o envio
 * (`canEmitSheetRecord`). Os endpoints de decisão exigem essa permissão: quem só
 * envia (`attendance_emitting`) chega às telas de auditoria pelo "Ver registro"
 * da fila de Pagamentos prioritários e levava 403 ao clicar em Aprovar/Rejeitar.
 */
export function useCanAuditAttendance(): ComputedRef<boolean> {
  const permissionsStore = usePermissionsStore()
  return computed(() =>
    [
      AuthorizationResourcesAndSubjects.DsAttendance,
      AuthorizationResourcesAndSubjects.DsAttendanceHealthUnit,
      AuthorizationResourcesAndSubjects.DsAttendanceCompany
    ].some((resourceType) =>
      permissionsStore.checkAnyRessources({
        permission: AuthorizationPermissions.AttendanceBasicReceiving,
        resourceType
      })
    )
  )
}

export const NO_AUDIT_PERMISSION_MESSAGE =
  'Você não tem permissão de auditoria nesta escala: o registro fica somente para leitura.'
